/* jshint esversion: 9 */
/**
 * Logistics Config : 网店物流配置
 *
 */

import { generate } from '@/utils/request';
const config = {
  prefix: '/schl/v1/{organizationId}/logistics/config',
  items: [
    /** 根据网店code获取物流配置列表 */
    { key: 'getLogisticsConfigByShopCode', url: '/getLogisticsConfigByShopCode', method: 'GET'},
    /** 批量更新网店物流配置 */
    { key: 'updateBatchLogisticsConfig', url: '/updateBatchLogisticsConfig', method: 'POST'},
    /** 根据物流代码更新网店物流状态 */
    { key: 'updateByLogisticsCodeLogisticsStatus', url: '/updateByLogisticsCodeLogisticsStatus', method: 'POST'},
  ],
};
export default {
  ...generate(config),
};
